import { Tag, Tooltip } from "antd";

interface Props {
  label: string;
  onClose: () => void;
}

/**
 * A removable filter chip that never grows wider than its column: long labels are cut with an
 * ellipsis (full text on hover) so the close icon always stays inside the chip's own column and
 * clickable, instead of overflowing underneath the neighbouring control (FOC-5608).
 */
function FilterTag({ label, onClose }: Props) {
  return (
    <Tooltip title={label}>
      <Tag className="m-3px filter-tag" closable onClose={onClose}>
        <span className="filter-tag-label">{label}</span>
      </Tag>
    </Tooltip>
  );
}

export default FilterTag;
